

export const FETCH_SETTINGS_REQUEST = 'settings/FETCH_SETTINGS_REQUEST';
export const FETCH_SETTINGS_SUCCESS = 'settings/FETCH_SETTINGS_SUCCESS';
export const FETCH_SETTINGS_FAILURE = 'settings/FETCH_SETTINGS_FAILURE';

export const UPDATE_SETTINGS_REQUEST = 'settings/UPDATE_SETTINGS_REQUEST';
export const UPDATE_SETTINGS_SUCCESS = 'settings/UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_FAILURE = 'settings/UPDATE_SETTINGS_FAILURE';

export const UPDATE_FIELD = 'settings/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'settings/SET_DEFAULT_DATA';
